import { render, staticRenderFns } from "./ResponsibleMenu.vue?vue&type=template&id=3cae6112"
import script from "./ResponsibleMenu.vue?vue&type=script&lang=js"
export * from "./ResponsibleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports